import ConfirmModal from '@sharedComponents/ConfirmModal';
import { useModal } from '@sharedContexts/ModalContext';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Opens the confirmation asked before unsaved changes are lost. `onConfirm` runs once the user accepts
// to leave; `onCancel` when they stay, through the cancel button or by closing the dialog.
const useConfirmDiscard = () => {
    const { t } = useTranslation('bo');
    const { actions } = useModal();

    return useCallback(
        ({ onConfirm, onCancel = () => {} }) => {
            const stay = () => {
                actions.close();
                onCancel();
            };
            actions.open({
                component: ConfirmModal,
                title: t('Unsaved changes'),
                size: 's',
                message: t('Your changes have not been saved. Leave without saving?'),
                cancelLabel: t('Stay'),
                confirmLabel: t('Leave without saving'),
                confirmTheme: 'danger',
                onCancel: stay,
                onClose: stay,
                onConfirm: () => {
                    actions.close();
                    onConfirm();
                },
            });
        },
        [actions, t],
    );
};

export default useConfirmDiscard;
